<template>
  <div class="calendar">
    <h2>Coming soon!</h2>
  </div>
</template>

<script>
export default {
  name: 'Calendar'
};
</script>

<style scoped>
.calendar {
  padding: 40 60px;
  color: black;
  font-size: 20px;
}
</style>